import React, { useEffect, useState } from 'react';
// ИСПРАВЛЕНО: Используем apiUrl вместо несуществующего api
import { apiUrl, appUrl, assetUrl } from '../config/paths';
import { Box, Typography, TextField, Button, Alert, InputAdornment } from '@mui/material';
import { Email, VpnKey } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

export default function QuickRequestEntry() {
  const _nav = useNavigate();
  const [email, setEmail] = useState('');
  const [code, setCode] = useState('');
  const [step, setStep] = useState<'email' | 'code'>('email');
  const [err, setErr] = useState<string | null>(null);
  const [ok, setOk] = useState<string | null>(null);
  const [expiresAt, setExpiresAt] = useState<string | undefined>();
  const [countdown, setCountdown] = useState<number | undefined>();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!expiresAt) return;
    const t = setInterval(() => {
      const now = Date.now(),
        exp = new Date(expiresAt).getTime();
      setCountdown(Math.max(0, Math.floor((exp - now) / 1000)));
    }, 1000);
    return () => clearInterval(t);
  }, [expiresAt]);

  const requestCode = async () => {
    setLoading(true);
    setErr(null);
    setOk(null);
    try {
      // ИСПРАВЛЕНО: api() → apiUrl()
      const r = await fetch(apiUrl('/auth/request-code'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });
      const d = await r.json();
      if (!r.ok) {
        if (r.status === 429 && d?.retryAfterSec) {
          setExpiresAt(new Date(Date.now() + d.retryAfterSec * 1000).toISOString());
        }
        throw new Error(d?.message || 'Ошибка отправки кода');
      }
      setOk(d?.message || 'Код отправлен на e-mail');
      setExpiresAt(d?.expiresAt);
      setStep('code');
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  };

  const verify = async () => {
    setLoading(true);
    setErr(null);
    setOk(null);

    try {
      // ИСПРАВЛЕНО: api() → apiUrl()
      const r = await fetch(apiUrl('/auth/verify-code'), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, code }),
      });
      const d = await r.json();

      if (!r.ok) throw new Error(d?.message || 'Неверный или истекший код');

      // ИСПРАВЛЕНО: Правильная обработка ответа API
      // Ответ: {"success":true,"token":"...","role":"client","user":{"email":"...","role":"..."}}
      const token = d?.token || d?.accessToken || d?.access_token;

      if (!token) {
        throw new Error('Токен не получен от сервера');
      }

      // Сохраняем токен в localStorage
      localStorage.setItem('token', token);

      // Сохраняем данные пользователя из ответа API
      const userData = d?.user || {
        email: email,
        role: d?.role || 'client',
      };
      localStorage.setItem('user', JSON.stringify(userData));

      // ДОБАВЛЕНО: Дублируем в sessionStorage для резервного механизма авторизации
      sessionStorage.setItem('token', token);
      sessionStorage.setItem('email', userData.email);
      sessionStorage.setItem('role', userData.role);

      // ИСПРАВЛЕНО: Правильный редирект на /client
      window.location.href = appUrl('/client');
    } catch (e: unknown) {
      setErr(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 650, mx: 'auto', my: 6, p: 2 }}>
      <Typography variant="h4" sx={{ mb: 1 }}>
        ГМСКЦ ТЕСТ ССТО
      </Typography>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Быстрая подача заявки на тестирование
      </Typography>

      {err && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {err}
        </Alert>
      )}
      {ok && (
        <Alert severity="success" sx={{ mb: 2 }}>
          {ok}
        </Alert>
      )}

      {step === 'email' && (
        <>
          <TextField
            fullWidth
            label="E-mail"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Email />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 2 }}
          />
          <Button
            disabled={!email || loading || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)}
            variant="contained"
            onClick={requestCode}
          >
            Получить код на e-mail
          </Button>
        </>
      )}

      {step === 'code' && (
        <>
          <TextField
            fullWidth
            label="Код (6 цифр)"
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/[^\d]/g, ''))}
            inputProps={{ maxLength: 6 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <VpnKey />
                </InputAdornment>
              ),
            }}
            sx={{ mb: 1 }}
          />
          {countdown !== undefined && (
            <Typography variant="caption" sx={{ display: 'block', mb: 2 }}>
              Срок действия кода: {Math.floor((countdown || 0) / 60)}:
              {((countdown || 0) % 60).toString().padStart(2, '0')}
            </Typography>
          )}
          <Button disabled={!email || !code || loading} variant="contained" onClick={verify}>
            Войти к форме заявки
          </Button>
        </>
      )}
    </Box>
  );
}
